







import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Rates from '@/components/rates/Rates.vue';
import { Building } from '@/modules/backend/Entities/Building';
import Mixin from '@/mixins/base';

const BuildingsModule = namespace('dashboard/buildings');

@Component({
  mixins: [Mixin],
  components: {
    rates: Rates
  }
})
export default class RatesTable extends Mixins(Mixin) {
  @BuildingsModule.Getter('BuildingById')
  public buildingById!: (buildingId: string | number) => Building;

  @BuildingsModule.Getter('Buildings')
  public buildings!: Building[];

  get buildingId(): string | number {
    return this.$route.params.buildingId;
  }

  get building(): Building {
    return this.buildingById(+this.buildingId);
  }
}
